import React, { useState } from 'react';

import { Icon, Label } from '@atlas/ui';

import useFormatter from 'src/hooks/useFormatter';

import {
  BONUS_FREESPIN_TERMS_ROWS,
  BONUS_TERMS_ROWS,
  resolveVisibleColumns,
  SPORT_BONUS_TERMS_ROWS,
} from './bonusDetailColumns';
import { useBonusDetailContext } from './BonusDetailContext';
import { BONUS_KIND } from './resolveBonusEntity';

const BonusDetailTerms = () => {
  const { entity, kind, loading } = useBonusDetailContext();
  const { currencyFormatter } = useFormatter(entity?.currency);
  const [isExpanded, setIsExpanded] = useState(false);

  const toggle = () => setIsExpanded(prev => !prev);

  const TERMS_ROWS_MAP = {
    [BONUS_KIND.FREESPIN]: BONUS_FREESPIN_TERMS_ROWS,
    [BONUS_KIND.SPORT]: SPORT_BONUS_TERMS_ROWS,
  };

  const termsRows = (TERMS_ROWS_MAP[kind] || TERMS_ROWS_MAP[entity?.type]) ?? BONUS_TERMS_ROWS;

  const terms = resolveVisibleColumns(termsRows, entity, currencyFormatter);

  if (loading || !terms.length) return null;

  return (
    <section className="bonus-details__terms panel">
      <button className="bonus-details__terms-header" onClick={toggle} type="button">
        <Label className="bonus-details__terms-title" message="additional_terms" />

        <Icon
          className="bonus-details__terms-arrow"
          name={isExpanded ? 'arrow-up' : 'arrow-down'}
        />
      </button>

      {isExpanded && (
        <div className="bonus-details__terms-list">
          {terms.map(({ content, header, id }) => (
            <div className="bonus-details__terms-row" key={id}>
              <span className="bonus-details__terms-label">
                <Label message={header} />
              </span>
              <span className="bonus-details__terms-value">{content}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default BonusDetailTerms;
